import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import cachingService from '../../services/caching_service';
import request from '../../utils/request_util';
import Base from '../base_model';
import log from '../../services/logger_service';

const CURRENT_YEAR = '2023'; // The current active franchise year

export default class Mic extends Base {
  static fetch({ year }, store) {
    const cleanedYear = this.cleanParam(year);

    /**
     * HANDLE LEGACY PAGES
     */
    if (cleanedYear < 2020 && cleanedYear > 2007) {
      const state = store.getState();
      const cacheEnabled = get(state, 'config.cacheEnabled');
      const cacheExpire = get(state, 'config.cacheExpire');
      const cacheNamespace = get(state, 'config.cacheNamespace');
      const host = 'assets.fastcompany.com';
      const options = {};
      const cacheKeyUrl = `https://${host}/multisite_files/fastcompany/mic/json/mic_${cleanedYear}.json`;
      const cacheKey = `${cacheNamespace}:${cacheKeyUrl}`;

      if (!cacheEnabled) {
        return request.getAsync(cacheKeyUrl, options);
      }

      return cachingService
        .getAsync(cacheKey)
        .then(function fromCache(cacheRes) {
          if (cacheRes) {
            return Promise.resolve(JSON.parse(cacheRes));
          }

          if (!canUseDOM) {
            log.info(`Requesting: ${cacheKeyUrl} from model.`);
          }

          return request
            .getAsync(cacheKeyUrl, options)
            .then(function fetchSuccess(resp) {
              cachingService.setex(cacheKey, cacheExpire, JSON.stringify(resp));
              return resp;
            });
        });
    }

    /**
     * HANDLE MODERN PAGES
     */
    const state = store.getState();
    const cacheEnabled = get(state, 'config.cacheEnabled');
    const cacheExpire = get(state, 'config.cacheExpire');
    const cacheNamespace = get(state, 'config.cacheNamespace');
    const host = 'fc-api.fastcompany.com';
    const options = {};

    // Handle subpage routing
    const subpageRoute = cleanedYear === 'list' ? CURRENT_YEAR : cleanedYear;

    // Don't worry about this token. Can be public. Talked to Harry.
    const cacheKeyUrl = `https://${host}/api/v1/franchise/mic-${subpageRoute}?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07`;
    const cacheKey = `${cacheNamespace}:${cacheKeyUrl}`;

    if (!cacheEnabled) {
      return request.getAsync(cacheKeyUrl, options);
    }

    return cachingService.getAsync(cacheKey).then(function fromCache(cacheRes) {
      if (cacheRes) {
        return Promise.resolve(JSON.parse(cacheRes));
      }

      if (!canUseDOM) {
        log.info(`Requesting: ${cacheKeyUrl} from model.`);
      }

      return request
        .getAsync(cacheKeyUrl, options)
        .then(function fetchSuccess(resp) {
          cachingService.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
    });
  }
}
